import React, {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";

import { s360ConfigService } from "../Services/S360Config";

import "../InitialForm/InitialFormStyleSheet.css";

function TextBox(props, ref) {
  const messageRef = useRef();
  const [errorMessage, setErrorMessage] = useState("");
  const [type, settype] = useState(0);
  const minLength = 2;
  const maxLength = 80;
  const mobileNoLenght = 10;

  const validateOnTheGo = (input, jsonField) => {
    let regex = null;

    setErrorMessage("");
    props.modifyLoginButton && props.modifyLoginButton(true);

    if (jsonField.primaryField || jsonField.required) {
      if (input.length === 0) {
        setErrorMessage(`${jsonField.label} is required`);
        props.modifyLoginButton && props.modifyLoginButton(false);
      } else if (input.length < minLength) {
        setErrorMessage(`${jsonField.label} length is too short`);
        props.modifyLoginButton && props.modifyLoginButton(false);
      } else if (input.length > maxLength) {
        setErrorMessage(`${jsonField.label} length is too big`);
        props.modifyLoginButton && props.modifyLoginButton(false);
      } else if (
        jsonField.label?.includes("Phone") ||
        jsonField.label?.includes("Mobile")
      ) {
        regex = /^\d+$/;
        if (!regex.test(input)) {
          setErrorMessage(`Enter Valid ${jsonField.label}`);
          props.modifyLoginButton && props.modifyLoginButton(false);
        } else if (input.length !== mobileNoLenght) {
          setErrorMessage(`${jsonField.label} too short`);
          props.modifyLoginButton && props.modifyLoginButton(false);
        }
      } else if (jsonField.label?.includes("Email")) {
        regex =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!regex.test(input)) {
          setErrorMessage(`Enter Valid ${jsonField.label}`);
          props.modifyLoginButton && props.modifyLoginButton(false);
        } else {
          setErrorMessage("");
          props.modifyLoginButton && props.modifyLoginButton(true);
        }
      }
    } else {
      props.modifyLoginButton && props.modifyLoginButton(true);
      if (input.length === 0) {
        setErrorMessage("");
        props.modifyLoginButton && props.modifyLoginButton(true);
      } else if (input.length < minLength) {
        setErrorMessage(`${jsonField.label} length is too short`);
        props.modifyLoginButton && props.modifyLoginButton(false);
      } else if (input.length > maxLength) {
        setErrorMessage(`${jsonField.label} length is too big`);
        props.modifyLoginButton && props.modifyLoginButton(false);
      } else if (
        jsonField.label?.includes("Phone") ||
        jsonField.label?.includes("Mobile")
      ) {
        regex = /^\d+$/;
        if (!regex.test(input)) {
          setErrorMessage(`Enter Valid ${jsonField.label}`);
          props.modifyLoginButton && props.modifyLoginButton(false);
        }
      } else if (jsonField?.label?.includes("Email")) {
        if (!input.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) {
          setErrorMessage(`Enter Valid ${jsonField.label}`);
          props.modifyLoginButton && props.modifyLoginButton(false);
        }
      } else {
        setErrorMessage("");
        props.modifyLoginButton && props.modifyLoginButton(true);
      }
    }
  };

  const value = useCallback(() => {
    if (
      !messageRef.current?.value ||
      !messageRef.current.value.trim() ||
      messageRef.current.value.trim() === props.item.label
    ) {
      return {};
    }
    let aValue = {};
    aValue[props.item.label] = messageRef.current.value;
    return aValue;
  }, [props.item.label]);

  useEffect(() => {
    if (
      document.getElementsByClassName(
        "s360-initial-form-textbox-input-container-small"
      ).length > 0
    ) {
      props.modifyLoginButton && props.modifyLoginButton(false);
    }
  }, [type]);

  useEffect(() => {
    setErrorMessage("");
    validateOnTheGo("", props.item);
  }, [s360ConfigService?.config?.form]);

  const isValidate = useCallback(
    (jsonField, input) => {
      if (jsonField.primaryField || jsonField.required) {
        if (input.value.length === 0) {
          setErrorMessage(`${jsonField.label} is required`);
          return false;
        } else if (input.value.length < minLength) {
          setErrorMessage(`${jsonField.label} length is too short`);
          return false;
        } else if (input.value.length > maxLength) {
          setErrorMessage(`${jsonField.label} length is too big`);
          return false;
        } else if (jsonField.validate === "Phone") {
          if (!input.value.match("^[0-9]*$")) {
            setErrorMessage(`Enter Valid ${jsonField.label}`);
            return false;
          }
        } else if (jsonField.validate === "Email") {
          if (!input.value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) {
            setErrorMessage(`Enter Valid ${jsonField.label}`);
            return false;
          }
        }
        return true;
      } else {
        if (input.value.length === 0) return true;
        if (input.value.length < minLength) {
          setErrorMessage(`${jsonField.label} length is too short`);
          return false;
        } else if (input.value.length > maxLength) {
          setErrorMessage(`${jsonField.label} length is too big`);
          return false;
        } else if (jsonField.validate === "Phone") {
          if (!input.value.match("^[0-9]*$")) {
            setErrorMessage(`Enter Valid ${jsonField.label}`);
            return false;
          }
        } else if (jsonField.validate === "Email") {
          if (!input.value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) {
            setErrorMessage(`Enter Valid ${jsonField.label}`);
            return false;
          }
        }
        return true;
      }
    },
    []
  );

  const validate = useCallback(() => {
    const jsonFildsArray = props.config.form;
    for (let i = 0; i < jsonFildsArray.length; i++) {
      let temp = "";
      if (messageRef.current?.placeholder.includes("*"))
        temp = messageRef.current?.placeholder.replace("*", "");
      else temp = messageRef.current?.placeholder;
      if (jsonFildsArray[i].label === temp) {
        return isValidate(jsonFildsArray[i], messageRef.current);
      }
    }
    return true;
  }, [isValidate, props.config.form]);

  const validationErrorMessage = useCallback(() => {
    return "Please enter " + props.item.label.toLowerCase() + ".";
  }, [props.item.label]);

  useImperativeHandle(
    ref,
    () => {
      return {
        value() {
          return value();
        },
        validate() {
          return validate();
        },
        validationErrorMessage() {
          return validationErrorMessage();
        },
      };
    },
    [validate, validationErrorMessage, value]
  );

  return (
    <div className="s360-initial-form-textbox-container">
      <label id={"lbl" + props.idxx} className="s360-initial-form-textbox-label">
        {`${props.item.label} ${props.item.required ? "*" : ""}`}
      </label>
      <fieldset className="s360-initial-form-textbox-input-container">
        <input
          autoFocus={props?.index === 0 ? true : false}
          onChange={(e) => {
            const { value } = e.target;
            let updatedValue = value;

            if (props.item.label.toLowerCase().includes("name")) {
              // Allow only alphabets and spaces
              updatedValue = value.replace(/[^a-zA-Z\s]/g, "");
            } else if (
              props.item.label.toLowerCase().includes("phone") ||
              props.item.label.toLowerCase().includes("mobile")
            ) {
              // Allow only numbers
              updatedValue = value.replace(/[^0-9]/g, "");
            }

            e.target.value = updatedValue;
            settype(type + 1);
            validateOnTheGo(updatedValue, props.item);
          }}
          type="text"
          id={props.idxx}
          ref={messageRef}
          className="s360-initial-form-textbox-input"
          placeholder={`${
            props.item.placeholder !== undefined
              ? props.item.placeholder
              : props.item.label
          }`}
          autoComplete="off"
          maxLength={
            props.item.label === "Phone Number" ||
            props.item.label === "Contact Number"
              ? props.item.maxLength
                ? props.item.maxLength
                : 10
              : 80
          }
        />
      </fieldset>
      {errorMessage !== "" && type !== 0 && (
        <small className="s360-initial-form-textbox-input-container-small">
          {errorMessage}
        </small>
      )}
    </div>
  );
}

export default forwardRef(TextBox);
